import { Component, Input } from '@angular/core';
import { AlertController, ModalController } from '@ionic/angular';
import { getDateWithTimezone, getFormattedShortStartEndDate } from '../../../utils/dates';
import { CurbUser } from '../../app.models';
import { AuthService } from '../../services/auth.service';
import { OpenHouseEventStatus, AgentOpenHouseModalData, AgentOpenHouseModalOutput } from '../../types';

@Component({
  selector: 'open-house-schedule-preview',
  templateUrl: './open-house-schedule-preview.html',
  styleUrls: ['./open-house-schedule-preview.scss'],
  standalone: false,
})
export class OpenHouseSchedulePreview {
  OpenHouseEventStatus = OpenHouseEventStatus;

  @Input('eventData') eventData: AgentOpenHouseModalData;
  @Input('currentUser') currentUser?: CurbUser;

  isEventFree: boolean = true;
  isEventPending: boolean = false;

  formattedDate: string;

  constructor(private modalCtrl: ModalController, private alertCtrl: AlertController, private auth: AuthService) {}

  async ngAfterContentInit() {
    this.isEventFree = this.eventData.status === OpenHouseEventStatus.free;

    if (!this.isEventFree && !this.eventData.agent) {
      this.auth.logErrors(`Agent is missing on assigned event on request modal. Event Id: ${this.eventData.eventId} | Agent Id: ${this.eventData.agent.objectID}`, false);
      throw new Error('Agent is required for assigned events');
    }

    this.formattedDate = getFormattedShortStartEndDate(this.eventData.start, this.eventData.end);

    const now = getDateWithTimezone(new Date(), this.currentUser.timezone);
    this.isEventPending = now.isBefore(this.eventData.end);
  }

  async requestEvent() {
    const confirmationAlert = await this.alertCtrl.create({
      header: 'Open House Request',
      message: "If accepted, you'll be assigned this Open House on the schedule.",
      buttons: [
        {
          text: 'Cancel',
        },
        {
          text: 'Request',
          handler: () => this._requestEvent(),
        },
      ],
    });

    await confirmationAlert.present();
  }

  _requestEvent() {
    this.modalCtrl.dismiss({
      action: 'request',
    } as AgentOpenHouseModalOutput);
  }

  close() {
    this.modalCtrl.dismiss();
  }
}
